import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';
import { ScheduleBlockFields } from '../Schedules/useScheduleBlocks';

const ClassDetailQuery = graphql.persisted(
  "ClassDetailQuery",
  graphql(`
    query ClassDetailQuery($classOfferingId: ID!) {
      classOffering(id: $classOfferingId) {
        id
        section
        displayName
        slug
        capacity
        scheduleInfo
        scheduleBlocks { ...ScheduleBlockFields }
        scheduleSeriesOfferings {
          id
          section
          displayName
          term { id name startsOn endsOn }
        }
        course {
          id
          name
          slug
          catalogCode
          gradeLevelKeys
          schoolYear {
            id
            startDate
            endDate
            terms { id name startsOn endsOn }
            school {
              id
              gradeLevelsSetting { items { description order } }
              staffMembers {
                id
                kind
                state
                person {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
        term {
          id
          name
          startsOn
          endsOn
        }
        rosterEntries {
          id
          state
          enrolledOn
          droppedOn
          healthRosterEligible
          person {
            id
            firstName
            lastName
          }
        }
        instructors {
          id
          role
          person {
            id
            firstName
            lastName
          }
        }
        gradebooks {
          id
          name
          transcriptName
          transcriptNameOverride
          creditValue
          transcriptCourse {
            id
            name
            creditValue
          }
          gradingMode
          finalized
          currentFinalization {
            id
            revision
            resultCount
            finalizedAt
          }
          finalizationPreview {
            ready
            nextRevision
            errors
            students {
              person { id firstName lastName }
              percentage
              letterGrade
              gpaPoints
            }
          }
          categories {
            id
            name
            weight
            dropLowest
            position
            locked
            lockedByGradebookNames
          }
          memberships {
            id
            rosterEntry {
              id
              state
              enrolledOn
              droppedOn
              person {
                id
                firstName
                lastName
              }
            }
          }
        }
        transcriptCourses {
          id
          name
          creditValue
          termCount
        }
        assignments {
          id
          name
          description
          pointsPossible
          dueOn
          position
          posted
          postedAt
          targets {
            id
            gradebook { id name }
            gradebookCategory { id name }
          }
          scores {
            id
            state
            pointsEarned
            comment
            lockVersion
            person { id firstName lastName }
          }
        }
        activeStudentCount
        studentCount
      }
    }
  `, [ScheduleBlockFields])
);

export { ClassDetailQuery };

export function useClassDetailQuery(classOfferingId?: string) {
  return useQuery(ClassDetailQuery, {
    variables: { classOfferingId: classOfferingId! },
    skip: !classOfferingId,
  });
}
